/** Shared with EmailVerificationBar — tour must not stack on the welcome coupon modal. */
export const GUIDED_ONBOARDING_COUPON_MODAL_SESSION_KEY = "nm_coupon_modal_pending";

/** Set while the user must replace a temporary / rotated password. */
export const GUIDED_ONBOARDING_PASSWORD_CHANGE_SESSION_KEY = "nm_password_change_required";

/** Fired when password-change (or other) deferral state changes so the tour can resume. */
export const GUIDED_ONBOARDING_DEFERRAL_CHANGED_EVENT = "nm-guided-onboarding-deferral-changed";

export function isGuidedOnboardingPasswordChangeRequired() {
  if (typeof window === "undefined") return false;
  try {
    return sessionStorage.getItem(GUIDED_ONBOARDING_PASSWORD_CHANGE_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

export function setGuidedOnboardingPasswordChangeRequired(required) {
  if (typeof window === "undefined") return;
  try {
    if (required) {
      sessionStorage.setItem(GUIDED_ONBOARDING_PASSWORD_CHANGE_SESSION_KEY, "1");
    } else {
      sessionStorage.removeItem(GUIDED_ONBOARDING_PASSWORD_CHANGE_SESSION_KEY);
    }
  } catch {}
  try {
    window.dispatchEvent(new CustomEvent(GUIDED_ONBOARDING_DEFERRAL_CHANGED_EVENT));
  } catch {}
}
